module.exports = __webpack_public_path__ + "img/icon5.6899cfe5.png";